import { useSearchParams } from "react-router";
import { EmptyState, Icon, type IconName } from "@omnabase/ui";
import { SEARCH_SECTIONS, type SearchResults } from "@omnabase/shared";
import { Shell } from "../shell/Shell";
import { useNav, useWs } from "../lib/nav";
import { useFetch } from "../lib/inbox";

/** /search?q=: one search across tickets and customers (the knowledge base and team chat arrive with their milestones). The top
 *  bar's field is the input; Enter on any list leads here, and on a screen without a list typing does. Ported from the prototype. */
const ICON: Record<string, IconName> = { tickets: "inbox", customers: "users" };
export function SearchScreen() {
  const nav = useNav(); const { ws, slug } = useWs();
  const [params] = useSearchParams();
  const q = params.get("q") ?? "";
  const ready = q.trim().length >= 2;
  const r = useFetch<SearchResults>(ready ? `/api/v1/w/${slug}/search?q=${encodeURIComponent(q)}` : null);
  const res = r.data;
  const shown = res ? res.tickets.length + res.customers.length : 0;
  return (
    <Shell crumbs={[{ label: "Search" }, ...(q ? [{ label: `“${q}”`, backLabel: "Search" }] : [])]} bodyClassName="ob-body--full">
      <main className="ob-page ob-searchpage" aria-label="Search results">
        {!ready ? <EmptyState icon="search" title="Search everything" text="Tickets and what was written in them, and customers with their sites. Type at least two characters in the search field at the top." />
          : !res ? (r.error ? <EmptyState icon="search" title="Could not search" text={r.error} /> : null)
          : res.total === 0 ? <EmptyState icon="search" title={`Nothing found for “${q}”`} text="Every word has to be found. Try fewer words, a ticket number like #4101, or part of an address." />
          : (
            <>
              <p className="ob-searchpage__count" role="status">{res.total} {res.total === 1 ? "result" : "results"}{shown < res.total ? ` · the first ${shown} shown` : ""}</p>
              {SEARCH_SECTIONS.filter((sec) => res[sec.id].length > 0).map((sec) => (
                <section key={sec.id} className="ob-searchpage__section" aria-label={sec.label}>
                  <h2 className="ob-searchpage__title"><Icon name={ICON[sec.id] ?? "search"} size="sm" />{sec.label}</h2>
                  <ul className="ob-needs ob-searchpage__list">
                    {res[sec.id].map((h) => {
                      const to = ws(h.to);
                      return (
                        <li key={h.id}><a className="ob-needs__row ob-searchpage__row" href={to} onClick={(e) => nav(to, e)}>
                          <span className="ob-needs__text"><span className="ob-needs__title">{h.title}</span><span className="ob-searchpage__snippet">{h.snippet}</span></span>
                          <span className="ob-searchpage__meta">{h.meta}</span>
                        </a></li>
                      );
                    })}
                  </ul>
                </section>
              ))}
            </>
          )}
      </main>
    </Shell>
  );
}
